import React from 'react';
import { ATMForm } from 'components/atoms/ATMForm/ATMForm.component';
export function CustomCheckbox({ value, onChange, ...props }: { value: boolean; onChange: (checked: boolean) => void;[key: string]: any }) {
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (!props.disabled) {
                onChange(!value);
            }
        }
    };

    return (
        <ATMForm.Field>
            <ATMForm.Checkbox
                {...props}
                checked={value}
                onChange={(e: any, data: any) => onChange(!!data.checked)}
                onKeyDown={handleKeyDown}
                label={props.text}
                style={{
                    ...props.style,
                }}
                className={`${props.className || ''} custom-checkbox-focusable`}
            />
        </ATMForm.Field>
    );
}
